<lovers-popup (onClose)="exibirPopup = false" [exibir]="exibirPopup" tamanho="pequeno">
  <div class="filtro__periodo__container">
    <div class="titulo">
      <p>Filtrar</p>
    </div>
    <div class="periodo__container">
      <div class="campo">
        <div class="header__tittle">
          <img class="icone__tittle" src="../../../../assets/images/icons/calendar.png" alt="Ícone filtro">
          <p class="titulo__campo">Período</p>
        </div>
        <p class="subtitulo__campo">Últimos períodos</p>
        <div class="filtro__dias">
          <div class="opcao__dia" *ngFor="let periodo of periodos; let i = index" [value]="periodo.valor"
            (click)="selecionarPeriodo(periodo)" [ngClass]="{'selecionado': periodo.selecionado}">
            {{ periodo.descricao }}
          </div>
        </div>
      </div>
      <div class="campo">
        <p class="subtitulo__campo">Selecionar período</p>
        <div class="filtro__dias">
          <input type="date" class="input__dias" placeholder="Data Inicial" [(ngModel)]="filtroDataInicial">
          <input type="date" class="input__dias" placeholder="Data Final" [(ngModel)]="filtroDataFinal">
        </div>
      </div>
      <div class="categoria__container">
        <div class="campo">
          <div class="header__tittle">
            <img class="icone__tittle" src="../../../../assets/images/icons/category.png" alt="Ícone filtro">
            <p class="titulo__campo">Categorias</p>
          </div>
          <div class="filtro__categorias">
            <div class="opcao__categoria" *ngFor="let tipo of tiposCategoria; let i = index"
              (click)="selecionarTipoCategoria(i)" [ngClass]="{'selecionado': tipo.selecionado}">
              {{ tipo.descricao }}
            </div>
          </div>
        </div>
      </div>
      <div class="campo">
        <div class="buttons">
          <label class="l__filtro" (click)="limparFiltros()">Limpar filtro</label>
          <button class="a__filtro" [ngClass]="{'disabled': loadingAplicar}" (click)="aplicarFiltro()">Aplicar <i
              *ngIf="loadingAplicar" class="fa fa-spinner fa-spin ajuste--carregar"></i></button>
        </div>
      </div>
    </div>
  </div>
</lovers-popup>

<div class="extrato">
  <div class="extrato__container">
    <div class="extrato__left">
      <div class="card__cacaus__pontos">
        <p class="card__tittle">Você tem</p>
        <div class="container__pontos">
          <div class="container__cacau">
            <p>
              <img src="assets/images/icons/cacau_moeda.png" />
              <ngx-skeleton-loader *ngIf="carregandoMembro" count="1" [theme]="{
                  'border-radius': '2px',
                  width: '1rem',
                  height: '1rem',
                  margin: '9px 2px 0 0'
                }"></ngx-skeleton-loader>
              <span *ngIf="carregandoMembro"> Cacaus </span>
              <span *ngIf="membro !== undefined">
                {{ membro.saldo.saldoPontos }}
              </span>
              <span *ngIf="membro !== undefined">
                {{ membro.saldo.saldoPontos > 1 ? "Cacaus" : "Cacau" }}
              </span>
            </p>
          </div>
          <div class="container__ponto" *ngIf="exibirSaldoPontos">
            <p>
              <img src="assets/images/icons/experiencia.png" />
              <ngx-skeleton-loader *ngIf="carregandoMembro" count="1" [theme]="{
                  'border-radius': '2px',
                  width: '1rem',
                  height: '1rem',
                  margin: '9px 2px 0 0'
                }"></ngx-skeleton-loader>
              <span *ngIf="carregandoMembro"> Pontos </span>
              <span *ngIf="membro !== undefined">
                {{ membro.saldo.saldoXP }}
              </span>
              <span *ngIf="membro !== undefined">
                {{ membro.saldo.saldoXP > 1 ? "Pontos" : "Ponto" }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="vencimentos">
        <p class="atual__descricao">Próximos vencimentos</p>
        <div class="vencimentos__info">
          <div class="container__infos">
            <div class="container__cacau">
              <p *ngIf="carregandoVencimentos">
                <img src="assets/images/icons/cacau_moeda.png" loading="lazy" alt="Cacau" />
                <ngx-skeleton-loader count="1" [theme]="{
                    'border-radius': '2px',
                    width: '1.5rem',
                    height: '1.5rem',
                    margin: '5px 8px 0 0'
                  }"></ngx-skeleton-loader>
                {{ membro?.saldo?.saldoPontos > 1 ? "Cacaus" : "Cacau" }}
              </p>
              <p class="validade--carregando" *ngIf="carregandoVencimentos">--/--/----</p>
              <p *ngIf="pontosAExpirar !== undefined">
                <img src="assets/images/icons/cacau_moeda.png" loading="lazy" alt="Cacau" />
                {{ pontosAExpirar.cacaus === null ? "-" : pontosAExpirar.cacaus }}
                {{ pontosAExpirar.cacaus > 1 ? 'Cacaus' : 'Cacau' }}
              </p>
              <p *ngIf="pontosAExpirar !== undefined" class="validade">
                {{
                pontosAExpirar.data === null
                ? ""
                : (pontosAExpirar.data | date : "dd/MM/yyyy")
                }}
              </p>
            </div>
          </div>
          <div class="container__infos" *ngIf="exibirSaldoPontos">
            <div class="container__vencimento">
              <p *ngIf="carregandoVencimentos">
                <img src="assets/images/icons/experiencia.png" loading="lazy" alt="Ícon de momento especial" />
                <ngx-skeleton-loader count="1" [theme]="{
                    'border-radius': '2px',
                    width: '1.5rem',
                    height: '1.5rem',
                    margin: '5px 8px 0 0'
                  }"></ngx-skeleton-loader>
                {{ membro?.saldo?.saldoXP > 1 ? "Pontos" : "Ponto" }}
              </p>
              <p class="validade--carregando" *ngIf="carregandoVencimentos">--/--/----</p>
              <p *ngIf="xpAExpirar !== undefined">
                <img src="assets/images/icons/experiencia.png" loading="lazy" alt="Ícon de momento especial" />
                {{ xpAExpirar.pontos === null ? "-" : xpAExpirar.pontos }}
                {{ xpAExpirar.pontos > 1 ? 'Pontos' : 'Ponto' }}
              </p>
              <p *ngIf="xpAExpirar !== undefined" class="validade">
                {{
                xpAExpirar.data === null
                ? ""
                : (xpAExpirar.data | date : "dd/MM/yyyy")
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="cashja">
        <p class="atual__descricao">Você já economizou</p>
        <div class="container__infos">
          <p *ngIf="carregandoVencimentos">
            <img src="assets/images/icons/healthicons_coins.png" loading="lazy" alt="Ícon de moeda" />
            <ngx-skeleton-loader count="1" [theme]="{
                'border-radius': '2px',
                width: '32px',
                height: '25px',
                margin: '9px 8px 0 0'
              }"></ngx-skeleton-loader>
          </p>
          <p *ngIf="!carregandoVencimentos" class="cashja__view">
            <img src="assets/images/icons/healthicons_coins.png" loading="lazy" alt="Ícon de moeda" />
            R$ 59,99
          </p>
        </div>
      </div>

      <div class="aviso__extrato">
        <img src="assets/images/icons/info.png" loading="lazy" alt="" />
        <div>
          <p [ngClass]="sizeFonteAviso">O extrato pode levar até um dia para ser atualizado.</p>
          <p [ngClass]="sizeFonteAviso" *ngIf="exibirMensagemDeQuantidadeMaximaDeCacaus">
            Quantidade máxima de Cacaus gerados por cupom fiscal: {{this.valorMaximoCacausPorCupom}}.
          </p>
        </div>
      </div>
    </div>
    <div class="extrato__right">
      <div class="tittle__plus__filters">
        <p class="tittle__movimentacoes">Movimentações</p>
        <div class="buttons__filter">
          <button class="botao__filtrar" (click)="abrirPopupFiltros(true)"
            [ngClass]="{ active: verificarSelecionado(this.periodos, this.tiposCategoria)}">
            <img class="icone__filtro" src="assets/images/icons/filter.png" /><span class="teste"
              *ngIf="width > 668">Filtrar</span>
          </button>
          <div class="input__pesquisa">
            <input class="pesquisar" type="text" placeholder="Buscar movimentação" [(ngModel)]="textoPesquisa" />
          </div>
        </div>
        <div class="div__filtros_selecionados">
          <p *ngFor="let item of obterFiltrosSelecionados(this.periodos)">
            <span *ngIf="item">
              {{ item.descricao }}
              <strong (click)="desmarcarItem(item)"><img class="remover" src="../../../../assets/images/icons/xis.svg" alt=""></strong>
            </span>
          </p>
          <p *ngFor="let item of obterFiltrosSelecionados(this.tiposCategoria)">
            <span *ngIf="item">
              {{ item.descricao }}
              <strong (click)="desmarcarItem(item)"><img class="remover" src="../../../../assets/images/icons/xis.svg" alt=""></strong>
            </span>
          </p>
          <p *ngIf="filtroDataInicial != null && filtroDataFinal != null">
            <span>
              {{ formatarDataInicialEFinal(filtroDataInicial, filtroDataFinal) }}
              <strong (click)="desmarcarData()"><img class="remover" src="../../../../assets/images/icons/xis.svg" alt=""></strong>
            </span>
          </p>
        </div>
      </div>
      <div class="operations__container" *ngIf="!carregandoExtrato && extrato.length > 0">
        <div *ngFor="let itemExtrato of extrato | extratoFilter: textoPesquisa" class="operation">
          <div class="operation__image">
            <img class="image" [src]="definirOperacaoIcone(itemExtrato)" [ngClass]="{
              'icone--grande': iconeEhResgate(itemExtrato.operacao)
            }" />
          </div>
          <div class="operation__name__points">
            {{ itemExtrato.operacao }}
            <div class="operation__points">
              <div class="points" *ngIf="itemExtrato.pontos != null && itemExtrato.operacao != 'Compra' && exibirSaldoPontos"
                [ngClass]="{'negative': itemExtrato.pontos < 0, 'positive': itemExtrato.pontos > 0, 'zerado': itemExtrato.pontos == 0}">
                <img src="assets/images/icons/experiencia.png" loading="lazy" alt="Pontos" />
                {{ positivoOuNegativo(itemExtrato.pontos)
                }}{{ itemExtrato.pontos }}
              </div>
              <div class="points" *ngIf="itemExtrato.pontos != null && itemExtrato.operacao == 'Compra' && exibirSaldoPontos"
                [ngClass]="{'negative': itemExtrato.pontos < 0, 'positive': itemExtrato.pontos > 0, 'zerado': itemExtrato.pontos == 0}">
                <img src="assets/images/icons/experiencia.png" loading="lazy" alt="Pontos" />
                {{ positivoOuNegativo(itemExtrato.pontos)
                }}{{ itemExtrato.pontos }}
              </div>
              <div class="cacaus" *ngIf="itemExtrato.cacaus != null && itemExtrato.operacao == 'Compra'"
                [ngClass]="{'negative': itemExtrato.cacaus < 0, 'positive': itemExtrato.cacaus > 0, 'zerado': itemExtrato.cacaus == 0}">
                <img src="assets/images/icons/cacau_moeda.png" loading="lazy" alt="Cacau" />
                {{ positivoOuNegativo(itemExtrato.cacaus)
                }}{{ itemExtrato.cacaus }}
              </div>
              <div class="cacaus" *ngIf="itemExtrato.cacaus != null && itemExtrato.operacao != 'Compra'"
                [ngClass]="{'negative': itemExtrato.cacaus < 0, 'positive': itemExtrato.cacaus > 0, 'zerado': itemExtrato.cacaus == 0}">
                <img src="assets/images/icons/cacau_moeda.png" loading="lazy" alt="Cacau" />
                {{ positivoOuNegativo(itemExtrato.cacaus)
                }}{{ itemExtrato.cacaus }}
              </div>
            </div>
          </div>
          <div class="operation__date__value">
            <div class="date">
              {{ itemExtrato.data | date : "dd/MM/yyyy" }}
            </div>
            <div class="value" *ngIf="itemExtrato.valor">
              {{ (itemExtrato.valor | moeda) }}
            </div>
          </div>
        </div>
      </div>
      <div class="carregamento" *ngIf="carregandoExtrato && width > 668">
        <ngx-skeleton-loader  count="5" [theme]="{
          'border-radius': '12px',
          width: '650px',
          height: '5rem',
          display: 'flex',
          'flex-direction': 'column',
          'margin-left': '-60px'
        }"></ngx-skeleton-loader>
      </div>
      <div class="carregamento" *ngIf="carregandoExtrato && width < 668">
        <ngx-skeleton-loader  count="5" [theme]="{
          'border-radius': '12px',
          width: '380px',
          height: '5rem',
          display: 'flex',
          'flex-direction': 'column'
        }"></ngx-skeleton-loader>
      </div>
      <div class="sem__movimentacao" *ngIf="carregandoExtrato && extrato.length === 0 && !buttonFiltrar">
        <img class="sem__movimentacao__icone" src="assets/images/icons/sem_movimentacao.png" alt="Filtro vázio">
        <p class="sem__movimentacao__texto">
          Sem movimentações, ainda.
        </p>
        <p class="sem__movimentacao__subtexto">
          Hmm, parece que você ainda não teve movimentações... Assim que você comprar um chocolate, vai aparecer aqui
          ;)
        </p>
      </div>
      <div class="sem__movimentacao" *ngIf="!carregandoExtrato && respostaExtrato.length == 0 && buttonFiltrar">
        <img class="sem__movimentacao__icone" src="assets/images/icons/extrado__zero__filter.png" alt="Filtro vázio">
        <p class="sem__movimentacao__texto">
          Nada por aqui...
        </p>
        <p class="sem__movimentacao__subtexto">
          O filtro selecionado não retornou nenhuma movimentação.
        </p>
      </div>
    </div>
  </div>
</div>
